import makeStyles from '@mui/styles/makeStyles';

import { UploadCSVType } from "../../../../../util/enums";

type StyleProps = {
  columnType: UploadCSVType;
  hasUploadFile?: boolean;
  isShipment: Boolean;
};

const styles = makeStyles(() => ({
  uploadOptionsContainer: {
    display: "flex",
    gap: "0.625rem",
    width: "45%",
    justifyContent: "space-between",
  },

  uploadOptionTypeContainer: {
    display: "flex",
    gap: "0.5rem",
    flexDirection: "column",
  },

  uploadOptionTypeLabelContainer: { display: "flex", gap: "0.5rem" },

  uploadOptionTypeLabelSection: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
  },

  roundedBlue: {
    width: "0.5rem",
    height: "0.5rem",
    backgroundColor: "#308CDB",
    borderRadius: "99px",
    alignItems: "flex-start",
  },

  uploadOptionTypeLabel: {
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "0.875rem",
    color: " #465869",
  },

  uploadOptionTypeDescription: {
    backgroundColor: (props: StyleProps) => {
      return props.hasUploadFile ? "#D1FADF" : "#E0F2FE";
    },
    borderRadius: "0.75rem",
    padding: "0.125rem 0.5rem",
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "0.875rem",
    marginLeft: "1rem",
    color: (props: StyleProps) => (props.hasUploadFile ? "#039855" : "#308CDB"),
  },

  uploadFileSection: {
    display: "flex",
    alignItems: "center",
  },

  uploadFileContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: (props: StyleProps) => (props.isShipment ? "none" : "1px solid #308CDB"),
    padding: (props: StyleProps) => (props.isShipment ? "none" : "0.5rem 0.75rem"),
    borderRadius: "0.5rem",
    cursor: "pointer",
  },
}));

export default styles;
